import { combineReducers } from 'redux';
import * as types from '../actions/ActionTypes';
import WordingService from '../services/WordingService';

const initialState = {
  login: null,
  identitiesId: null,
  loginError: {
    valid: true,
    errorMessage: '',
  },
};

/**
 * String login
 * @param state
 * @param action
 */
export const login = (state = initialState.login, action) => {
  switch (action.type) {
    case types.CREATE_IDENTITIES:
      return action.payload.login || state;
    case types.RECEIVE_ACCESS_NEW_SESSION:
      return action.payload.login || state;
    default:
      return state;
  }
};

/*
 * Reducer function that takes the previous status state and an action,
 * and calculate the next status state and return it
 */
export const identitiesId = (state = initialState.identitiesId, action) => {
  switch (action.type) {
    case types.CREATE_IDENTITIES_SUCCESS:
    case types.RECEIVE_ACCESS_BYPASS:
      return action.payload.identitiesId;
    case types.CREATE_IDENTITIES_FAILURE:
    default:
      return state;
  }
};

/**
 * Boolean reducer to check login credentials
 * @param state
 * @param action
 * @return {*}
 */
export const loginError = (state = initialState.loginError, action) => {
  switch (action.type) {
    case types.CLEAR_INPUT_ERROR:
      if (action.payload.field === 'login') {
        return {
          errorMessage: '',
          valid: true,
        };
      }
      return state;
    case types.SET_INPUT_ERROR:
      if (action.payload.field === 'login') {
        switch (action.payload.error) {
          case 'empty':
            return {
              valid: false,
              errorMessage: WordingService.getWording('errorMessage', 'noLogin'),
            };
          case 'invalidUser':
            return {
              valid: false,
              errorMessage: WordingService.getWording('errorMessage', 'invalidUser'),
            };
          case 'syntaxInvalid':
            return {
              valid: false,
              errorMessage: WordingService.getWording('errorMessage', 'syntaxInvalid'),
            };
          default:
            return state;
        }
      }
      return state;
    default:
      return state;
  }
};

export default combineReducers({
  login,
  identitiesId,
  loginError,
});
